import { CreditCardEditorModule } from 'components/creditCards/creditCardEditor/creditCardEditor.module';
import { CreditCardUtilitiesServiceModule } from 'services/utilities/creditCardUtilities.service';
import { AddressEditorModule } from 'components/addressEditor/addressEditor.directive';
import { UpdatePaymentServiceModule } from '../updatePayment.service';

export const UpdatePaymentModalController = angular
    .module('app.components.updatePaymentModal.updatePaymentModalController', [
        'ngMaterial',
        CreditCardEditorModule,
        CreditCardUtilitiesServiceModule,
        AddressEditorModule,
        UpdatePaymentServiceModule
    ]).controller('UpdatePaymentModalController', (
        $scope,
        $mdDialog,
        creditCardUtilities,
        updatePaymentService,
        editMode,
        prefillData
    ) => {
        var vm = {
            changePaymentMethod,
            cancel,
            card: creditCardUtilities.newCard(),
            billingAddress: {},
            loading: false,
            errorTextVisible: false,
            editMode,
            errorText: 'There was an issue updating your payment info.'
        };

        init();

        function init() {
            $scope.vm = vm;
            if (angular.isDefined(prefillData) && prefillData !== null) setPrefillData(prefillData);
        }

        function setPrefillData(data) {
            vm.billingAddress = data.address;
            vm.card = {
                cardNumber: data.maskedCardNumber,
                expiration: data.expirationString
            };
        }

        function changePaymentMethod() {
            vm.loading = true;
            vm.errorTextVisible = false;

            updatePaymentService.changePaymentMethod(vm.card, vm.billingAddress).then(() => {
                $mdDialog.hide(convertForm(vm.card, vm.billingAddress));
            }, (err) => {
                vm.loading = false;
                if (err.message) vm.errorText = err.message;
                vm.errorTextVisible = true;
            });
        }

        function convertForm(card, billingAddress) {
            return {
                lastFour: creditCardUtilities.getLastFour(card.cardNumber),
                maskedCardNumber: creditCardUtilities.getMaskedCardNumber(card.cardNumber),
                brand: card.cardTypeName,
                expiration: creditCardUtilities.parseExpiration(card.expiration),
                expirationString: card.expiration,
                address: billingAddress
            };
        }

        function cancel() {
            $mdDialog.cancel();
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/updatePayment/updatePaymentModal/updatePaymentModal.controller.js